import React, { useEffect, useState } from "react";
import { IMAGE_URL } from "config";
import { Box, Grid, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Link } from "react-router-dom";
import { useGetAllCatererQuery } from "api/caterer";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from "react-redux";
import { add, remove } from "store/Reducers/cartSlice";
import { addDish, removeDish, updateQuantity } from "store/Reducers/DishSlice";

export default function CheckoutOderSummery({ setsubDetails, subDetails }) {
  const { selectedDishes } = useSelector((state) => state.dishes)
  // const { selectedDishes } = useSelector((state) => state.dishes)
  console.log("selectedDishes", selectedDishes)
  // let Cart = useSelector((state) => state.reduxReducers);
  const [cart, setCart] = useState(selectedDishes)
  // let cart = 
  console.log(cart);
  const dispatch = useDispatch();
  // let navigate = useNavigate();

  useEffect(() => {
    setsubDetails({ ...subDetails, menu: selectedDishes });
    setCart(selectedDishes)
    console.log(subDetails);
  }, [selectedDishes]);

  useEffect(() => {
    if (!cart || cart.length === 0) {
      Swal.fire("No any menu in your bucket", "", "error");
    }
  }, []);
  function handleIncr(id) {
    let menuData = [...cart];
    let find = menuData.find((v) => v.dish._id == id);
    if (find) {
      console.log("find", find)
      // let temp = { ...find };
      // temp.quantity = temp.quantity + 1;
      // temp.addToCart = true;
      dispatch(addDish(find?.dish));
    }
  }

  function handleDec(id) {
    let menuData = [...cart];
    let find = menuData.find((v) => v.dish._id == id);
    if (find) {
      console.log("find", find)

      dispatch(updateQuantity(find));
      // let temp = { ...find };
      // if (temp.quantity > 1) {
      //   // temp.quantity = temp.quantity - 1;

      // }
    }
  }

  function handleDelete(dishId) {
    console.log("id", dishId); // Check if dishId is coming here properly
    dispatch(removeDish({ dishId }));
  }
  return (
    <>
      <Box>
        {/* <Grid
          container
          spacing={4}
          sx={{
            display: "flex",
            flexDirection: "row",
            padding: "0px 30px",
            border:"1px solid red"
          }}
        > */}
        {cart &&
          cart.length > 0 &&
          cart.map((v, i) => {
            console.log(v)
            return (
              <>
                <Grid xl={12} item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      width: {
                        lg: "100%",
                        md: "100%",
                        sm: "100%",
                        xs: "fit-content",
                      },
                      border: "2px solid #F1F1F1",
                      borderRadius: "10px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      my: 1,
                      // border: "1px solid red",
                    }}
                  >
                    <Link
                      //  to={"/caterer/detail/"+v._id}
                      to={"#"}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      <Box
                        sx={{
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                          padding: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            width: {
                              xl: "96px",
                              lg: "96px",
                              md: "96px",
                              sm: "96px",
                              xs: "96px",
                            },
                            height: {
                              xl: "96px",
                              lg: "96px",
                              md: "96px",
                              sm: "96px",
                              xs: "96px",
                            },
                            overflow: "hidden",
                            borderRadius: "5px",
                          }}
                        >
                          <img
                            src={
                              v?.dish?.image
                                ? IMAGE_URL + v?.dish?.image
                                : "/images/chef" +
                                (Math.floor(Math.random() * 3) + 1) +
                                ".jpg"
                            }
                            alt=""
                            width="100%"
                            height="100%"
                            style={{ borderRadius: "5px" }}
                          />
                        </Box>

                        <Box>
                          <Box>
                            <Typography
                              sx={{
                                fontSize: {
                                  xl: "30px",
                                  lg: "24px",
                                  md: "24px",
                                  sm: "20px",
                                  xs: "18px",
                                },
                                fontWeight: "600",
                              }}
                            >
                              {v.dish.name}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <Typography
                              color="#545359"
                              sx={{
                                fontSize: {
                                  xl: "16px",
                                  lg: "14px",
                                  md: "14px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                              }}
                            >
                              {v.quantity ? v.quantity : 0}{" "}
                              Dishes
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <Typography
                              color="#545359"
                              sx={{
                                fontSize: {
                                  xl: "16px",
                                  lg: "14px",
                                  md: "14px",
                                  sm: "10px",
                                  xs: "8px",
                                },
                              }}
                            >
                              {v.cuisine} Cuisine
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              color: "#FAA641",
                            }}
                          >
                            <Box
                              sx={{
                                pr: "10px",
                              }}
                            ></Box>
                          </Box>
                        </Box>
                      </Box>
                    </Link>
                    <Box
                      sx={{
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography>${v.dish.price * v.quantity}</Typography>
                      <Box
                        sx={{
                          display: `flex`,
                          flexDirection: "row",
                          ajustifyContent: "space-around",
                        }}
                      >
                        <Box>
                          <IconButton
                            size="small"
                            sx={{
                              backgroundColor: "#F0FAF9",
                            }}
                            onClick={() => {
                              handleDec(v.dish._id);
                            }}
                          >
                            <RemoveIcon sx={{ color: "#2B817B" }} />
                          </IconButton>
                        </Box>
                        <Box sx={{ ml: "11px", mr: "11px", marginTop: "4px" }}>
                          <Typography>{v.quantity}</Typography>
                        </Box>
                        <Box>
                          <IconButton
                            size="small"
                            sx={{
                              backgroundColor: "#F0FAF9",
                            }}
                            onClick={() => {
                              handleIncr(v.dish._id);
                            }}
                          >
                            <AddIcon sx={{ color: "#2B817B" }} />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        padding: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <DeleteIcon
                        style={{ color: "red" }}
                        onClick={() => {
                          handleDelete(v.dish._id);
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              </>
            );
          })}
        {/* </Grid> */}
      </Box>
    </>
  );
}
